import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_h_header = _resolveComponent("h-header")!
  const _component_h_header_mobile = _resolveComponent("h-header-mobile")!
  const _component_h_modal_error = _resolveComponent("h-modal-error")!
  const _component_h_modal_dob_error = _resolveComponent("h-modal-dob-error")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_h_footer = _resolveComponent("h-footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_h_header),
    _createVNode(_component_h_header_mobile),
    _createVNode(_component_h_modal_error),
    _createVNode(_component_h_modal_dob_error),
    _createVNode(_component_router_view),
    _createVNode(_component_h_footer)
  ], 64))
}